import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'; // Use DateTimePicker for date & time selection
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateField } from '@mui/x-date-pickers/DateField'; // Assuming you have a DateField component
import { useTranslation } from 'react-i18next';

const TimeRangeSelector = ({ setTimeRange, timeRange }) => {
  // Display start and end dates in local time but convert to UTC when storing
  const [startDate, setStartDate] = useState(
    DateTime.fromMillis(timeRange.start),
  ); // Local time
  const [endDate, setEndDate] = useState(DateTime.fromMillis(timeRange.end)); // Local time

  const { t } = useTranslation('translation');

  const handleStartDateChange = (newStartDate) => {
    if (newStartDate <= DateTime.now() && newStartDate <= endDate) {
      setStartDate(newStartDate);

      // Store the UTC timestamp in the state
      setTimeRange({
        start: newStartDate.toUTC().toMillis(), // Convert to UTC before storing
        end: endDate.toUTC().toMillis(), // Keep end date in UTC
      });
    }
  };

  const handleEndDateChange = (newEndDate) => {
    if (newEndDate <= DateTime.now() && newEndDate >= startDate) {
      setEndDate(newEndDate);

      // Store the UTC timestamp in the state
      setTimeRange({
        start: startDate.toUTC().toMillis(), // Keep start date in UTC
        end: newEndDate.toUTC().toMillis(), // Convert to UTC before storing
      });
    }
  };

  // const handleTodayClick = () => {
  //     const today = DateTime.now();
  //     const startOfDay = today.startOf('day').toLocal(); // Local time for the start of the day
  //     const endOfDay = today.toLocal(); // Local time for the current moment

  //     setStartDate(startOfDay); // Display start of the day in local time
  //     setEndDate(endOfDay); // Display current moment in local time

  //     // Store the local time values (not UTC) in the state
  //     setTimeRange({
  //         start: startOfDay.toMillis(), // Local time in milliseconds
  //         end: endOfDay.toMillis(), // Local time in milliseconds
  //     });
  // };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Box sx={{ display: 'flex' }}>
        <DateTimePicker
          label={t('translation:from')}
          value={startDate}
          onChange={handleStartDateChange}
          maxDateTime={DateTime.now()} // Restrict future dates and times
          renderInput={(params) => <DateField {...params} />} // Keep using DateField here
          slotProps={{
            textField: {
              variant: 'standard',
              size: 'small',
              InputProps: {
                disableUnderline: true,
              },
              InputLabelProps: {
                shrink: true, // Always keep the label in the "shrunken" state
              },
              sx: {
                '& .MuiInputBase-root': {
                  borderRadius: '5px', // Customize border radius here
                },
                '& .MuiFilledInput-root': {
                  borderRadius: '5px', // Customize border radius for filled variant
                },
              },
            },
          }}
        />
        <Box sx={{ mx: 2, display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1">-</Typography>
        </Box>
        <DateTimePicker
          label={t('translation:to')}
          value={endDate}
          onChange={handleEndDateChange}
          minDateTime={startDate} // Enforce end date not before start date
          maxDateTime={DateTime.now()} // Restrict future dates and times
          renderInput={(params) => <DateField {...params} />} // Keep using DateField here
          slotProps={{
            textField: {
              variant: 'standard',
              size: 'small',
              InputProps: {
                disableUnderline: true,
              },
              InputLabelProps: {
                shrink: true, // Always keep the label in the "shrunken" state
              },
              sx: {
                '& .MuiInputBase-root': {
                  borderRadius: '5px', // Customize border radius here
                },
                '& .MuiFilledInput-root': {
                  borderRadius: '5px', // Customize border radius for filled variant
                },
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default TimeRangeSelector;
